module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"dataTypeName":"Veri tipi","emissionTypeColumn":"Emisyon Tipi","factorColumn":"Emisyon Faktörü","factorPlaceHolder":"Emisyon kat sayısı","unitColumn":"Birim","startDateColumn":"Başlangıç Yılı","endDateColumn":"Bitiş Yılı"},"en":{"dataTypeName":"Data type","emissionTypeColumn":"Emission Type","factorColumn":"Emission Factor","factorPlaceHolder":"Emission Factor","unitColumn":"Unit","startDateColumn":"Start Year","endDateColumn":"End Year"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Setting/EmissionDetail.vue
// module id = pJEE
// module chunks = 1